// Venue roles (docs/roles.md, "How roles are given"). A login holds one role at one venue:
// users/{uid} carries `role` and `customerIds` (the first is the venue the role is for), and the
// claims follow them. Giving a role here therefore takes away a role at another venue.

// the one-liners follow RolesHelp.jsx, the fuller Finnish description of each role
export const VENUE_ROLES = [
  { value: 'admin', label: 'Admin', help: 'Paikan ylläpitäjä: kaikki toiminnot ja asetukset' },
  { value: 'cashier', label: 'Cashier', help: 'Kassa ja vastaanotto: varaukset ja maksut, ei asetuksia, laskutusta eikä raportointia' },
  { value: 'partner', label: 'Partner', help: 'Yhteistyökumppani, esim. valmennusyritys: varaa omalla nimellään, ei näe hintoja eikä maksuja' },
  { value: 'cooperative', label: 'Cooperative', help: 'Kuten partner, mutta muiden varaukset näkyvät vain harmaina' },
]

export const roleLabel = (role) => {
  const found = VENUE_ROLES.find((r) => r.value === String(role || '').toLowerCase())
  return found ? found.label : String(role || '')
}

// 'none'      no login (no users doc), so no role can be given
// 'user'      a customer account without a venue role
// 'here'      already has a role at this venue
// 'elsewhere' has a role at another venue, which the new role replaces
export const accountStatus = (account, customerid) => {
  if (!account || !account.exists) return 'none'
  const role = String(account.role || 'USER').toUpperCase()
  if (role === 'USER') return 'user'
  const venue = Array.isArray(account.customerIds) ? account.customerIds[0] : null
  return venue === customerid ? 'here' : 'elsewhere'
}
